class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.selectLabel = this.querySelector(".custom-select__label");
    this.selectList = this.querySelector(".custom-select__list");
    this.selectListItems = this.querySelectorAll(".custom-select__list_item");
    this.selectFilter = this.querySelector(".custom-select__filter");
    this.selectOverlay = this.querySelector(".select__select_custom_overlay");
    this.currentSelectId = this.id;

    this.selectFilter.addEventListener("input", this.filterList.bind(this));
    this.selectLabel.addEventListener("click", this.toggle.bind(this));
    this.selectOverlay.addEventListener("click", this.close.bind(this));
    this.selectListItems.forEach((item) => {
      item.addEventListener("click", this.close.bind(this));
    });
  }

  resetSelects() {
    const selectList = document.querySelectorAll("custom-select");

    selectList.forEach((item) => {
      if (item !== this) {
        const list = item.querySelector(".custom-select__list");
        list.classList.remove("open");
      }
    });
  }

  toggle() {
    // this.resetSelects();
    this.selectList.classList.toggle("open");
    this.selectOverlay.classList.toggle("open");
  }

  close(e) {
    this.selectList.classList.remove("open");
    this.selectOverlay.classList.remove("open");

    if (!e.currentTarget.dataset.value) return;
    this.changeOptionValue(e.currentTarget.dataset.value);
  }

  changeOptionValue(value) {
    this.selectLabel.querySelector("span").textContent = value;
  }

  filterList(e) {
    this.selectListItems.forEach((item) => {
      if (
        item.dataset.value.toLowerCase().includes(e.target.value.toLowerCase())
      ) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });
  }
}

customElements.define("custom-select", CustomSelect);
